export default class VoicesColor {
    constructor(controller) {
        this.controller = controller;
        this.init();
    }

    init() {
        this.voicesColor();
    }

    voicesColor() {
        function Color() {
            const swiperSlides = document.querySelectorAll('.js-swiper-slide');

            swiperSlides.forEach((swiperSlide) => {
                const num = parseInt(swiperSlide.dataset.swiperSlideIndex);
                if (num % 2 === 0) {
                    swiperSlide.classList.add('-even');
                } else {
                    swiperSlide.classList.add('-odd');
                }
            });
        }
        Color();
    }
}
